import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Channel = props => {
  const [showX, setShowX] = useState(false)

  const onClickX = (e) => {
    e.stopPropagation()
    if (window.confirm('Are you sure you want to close this conversation?')) {
      props.onClose()
    }
  }

  const dateTime = () => {
    if (!props.date) return ''

    if (moment().diff(moment(props.date), 'day') >= 2) moment(props.date).fromNow()
    return moment(props.date).calendar(null, { sameDay: 'hh:mm a', lastDay: '[Yesterday]' })
  }

  return (
    <div className={classNames('channel', {'selected': props.selected})} 
      onMouseOver={() => setShowX(true)}
      onMouseLeave={() => setShowX(false)}
      onClick={props.onSelect}
    >
      { showX && 
        <button className='channel__close' onClick={onClickX}>
          <i className= 'fa fa-times'></i>
        </button>
      }
      <div className='avatar'>
        <img className='avatar-image' src={props.player && props.player.image_url || '/images/ic_user@2x.png'} />
      </div>
      <div className='channel__content'>
        <div className='channel__header'>
          <div className='player-info'>
            <div className='name'>{props.player && `${props.player.first_name} ${props.player.last_name}` || 'Unknown'}</div>
            <div className='region'>{props.player && props.player.region_name || 'Unknown'}</div>
          </div>
          <div className='date'>{dateTime()}</div>
        </div>
        <div className='text'>
          <div className='last'>{props.lastMessage.text}</div>
          { props.unseenCount > 0 &&
            <div className='unseen'>{Math.min(props.unseenCount, 99)}</div>
          }
        </div>
      </div>
    </div>
  )
}

Channel.propTypes = {
  id: PropTypes.number,
  player: PropTypes.object,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  lastMessage: PropTypes.object,
  unseenCount: PropTypes.number,
  date: PropTypes.instanceOf(Date)
}

export default Channel
